import { differenceInCalendarDays } from 'date-fns';
import { Colors } from '../../../models/disciplines';
import { Button } from '../../atoms/Button';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../Typography';
import { RevisionCardIcon } from './variants';
import { getDisciplineIcon } from '../../../utils/discipline';

export interface IRevisionCard {
  title: string;
  area: string;
  subject: string;
  dateToReview: Date | string;
  futureReview: boolean;
  reviewAction: () => void;
  excludeAction: () => void;
  onTitleAction?: () => void;
}

export function RevisionCard({
  title,
  area,
  subject,
  dateToReview,
  futureReview,
  reviewAction,
  excludeAction,
  onTitleAction,
}: IRevisionCard) {
  const buildDate = () => {
    const time = differenceInCalendarDays(new Date(dateToReview), new Date());

    if (time > 0) {
      return time;
    } else {
      return time + 1;
    }
  };

  return (
    <div className='flex justify-between rounded-md bg-color-lightest p-4 shadow-level-2 xs:flex-col xs:gap-4 lg:flex-row'>
      <div className='flex gap-2 xs:flex-col xs:items-start lg:flex-row lg:items-center'>
        <Typography type='title' size='h4' className='flex items-center gap-2'>
          <Icon
            Icon={getDisciplineIcon(area)}
            type='svg'
            className={RevisionCardIcon({ color: area as Colors })}
          />
          {subject}
        </Typography>
        <Button
          variant='text'
          size='small'
          onClick={() => onTitleAction && onTitleAction()}
          className={`${
            onTitleAction === null ? 'cursor-pointer' : 'cursor-default'
          }`}
          loading={false}
        >
          {title}
        </Button>
      </div>
      <div className='flex gap-4'>
        <Button
          className='xs:w-full xs:justify-center lg:w-auto'
          disabled={futureReview}
          onClick={() => reviewAction()}
        >
          {futureReview
            ? 'Revisar em ' + buildDate() + ' dia(s)'
            : 'Revisar assunto'}
        </Button>
        <Button
          variant='outlined'
          className='text-feedback-color-error-pure xs:hidden lg:flex'
          onClick={() => excludeAction()}
        >
          Excluir da lista
        </Button>
        <Button
          variant='outlined'
          LeftIcon={'delete'}
          className='text-feedback-color-error-pure xs:flex lg:hidden'
          onClick={() => excludeAction()}
        />
      </div>
    </div>
  );
}
